import { render } from "./SelectorDetails.vue?vue&type=template&id=ec483df6"
import script from "./SelectorDetails.vue?vue&type=script&lang=js"
export * from "./SelectorDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__